// extracted by mini-css-extract-plugin
module.exports = {"video-link":"j_n d-flex align-items-center my-2","video-link__link":"j_p ml-2"};